import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import StaffListCard from './StaffListCard';

export default function StaffListCards(props) {
  return (
    <Grid
      container
      direction="row"
      style={{
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '0 2.50em',
      }}
    >
      {props.adminList.map((staff) => {
        return (
          <Grid item xs={12} sm={12} md={5} lg={6} align="center" key={staff.id}>
            <StaffListCard staff={staff} handleEditStaff={props.handleEditStaff} />
          </Grid>
        );
      })}
    </Grid>
  );
}

StaffListCards.propTypes = {
  adminList: PropTypes.array.isRequired,
  handleEditStaff: PropTypes.func.isRequired,
};
